import { FC } from 'react';
import { useLottie } from 'lottie-react';
import LoadingSpinnerAnimationData from 'app/shared/lottieAnimations/loadingSpinner.json';
import styles from 'app/modules/insights/components/initializingStatus/initializingSpinner/InitializingSpinner.module.scss';
import { useTranslation } from 'react-i18next';

const animationStyles = {
  maxWidth: '175px',
  maxHeight: '175px',
  background: 'transparent',
};

const animationOptions = {
  animationData: LoadingSpinnerAnimationData,
  loop: true,
  autoplay: true,
};

type Props = {
  text?: string;
};

const InitializingSpinner: FC<Props> = ({ text }) => {
  const { View } = useLottie(animationOptions, animationStyles);
  const { t } = useTranslation();

  return (
    <div className={styles.initializingSpinner}>
      {View}
      <span className={styles.text}>
        {text ?? t('insights.initializing.spinnerText')}
      </span>
    </div>
  );
};

export default InitializingSpinner;
